//Button variants
export const VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  SUBTLE: 'subtle',
  SUBTLE_LEFT: 'subtle-left',
  SUBTLE_RIGHT: 'subtle-right',
  AI: 'ai',
  AI_TERTIARY: 'ai-tertiary'
};

//Button colors
export const COLORS = {
  PRIMARY: 'primary',
  DESTRUCTIVE: 'destructive',
  UPGRADED: 'upgrade'
};

//Sizes
export const SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium'
};

//Arrow Icon
export const ARROWICON = {
  UP: 'up',
  DOWN: 'down'
};